import React from "react";
import { useUI } from "../stores/useUI";
import DevMenu from "./ui/DevMenu";
import LevelMenuIslands from "./LevelMenuIslands";  
import LoadingTracker from "./ui/LoadingTracker";
import { IsProduction } from "../utils/client";
import MainHeader from "./ui/MainHeader";
import { useDialogs } from "../stores/useDialogs";
import StatsPopup from "./ui/StatsPopup";
import Minimap from "./ui/Minimap";

const UI = ({ isWarmingUp }: { isWarmingUp: boolean }) => {
  const { currentMap, setCurrentMap, resetLoadingTracker, startGame, setStartGame } = useUI();
  const { resetDialogState } = useDialogs();
  
  const handleBackToMenu = () => {
    setCurrentMap(null);
    setStartGame(false);
    resetLoadingTracker();
    resetDialogState();
  };
  const handleMapSelect = (mapId: string) => {
    setCurrentMap(mapId);
  };
  const showLoadingTracker = (currentMap && !startGame) || (currentMap && isWarmingUp);

  if (showLoadingTracker) {
    return (
      <>
        <LoadingTracker />
      </>
    );
  }

    return (
      <>
        {!currentMap && <LevelMenuIslands onMapSelect={handleMapSelect} />}
        <MainHeader handleBack={handleBackToMenu} />
        <StatsPopup />
        <Minimap />
        {!IsProduction && <DevMenu/>}
      </>
    );
};

export default UI;